import React from 'react';
import { X, Download } from 'lucide-react';

interface DownloadAppModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export const DownloadAppModal: React.FC<DownloadAppModalProps> = ({
  isOpen,
  onClose,
  title = 'Please Download the App'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal Content */}
      <div className="light relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 text-center animate-in fade-in zoom-in duration-200">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="w-20 h-20 bg-[#006B82]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Download className="w-10 h-10 text-[#006B82]" />
        </div>

        <h2 className="text-2xl font-bold text-gray-900 mb-3">{title}</h2>

        <p className="text-gray-600 mb-6">
          This feature is available in our mobile app. Please download the app
          to access this functionality.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onClose}
            className="w-full py-3 px-6 bg-[#006B82] text-white rounded-xl font-medium hover:bg-[#005A6E] transition"
          >
            Download App
          </button>
          <button
            onClick={onClose}
            className="w-full py-3 px-6 border border-gray-300 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};
